// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.billing-panel[data-v-766c024c] {
    background: var(--billing-card-bg);
    border: 1px solid var(--billing-border);
    border-radius: 8px;
    box-shadow: 0 18px 40px rgba(4, 14, 30, 0.12);
}
`, "",{"version":3,"sources":["webpack://./portal/static/components/BillingAccounts/Shared/BillingPanel.vue"],"names":[],"mappings":";AAaA;IACI,kCAAkC;IAClC,uCAAuC;IACvC,kBAAkB;IAClB,6CAA6C;AACjD","sourcesContent":["<template>\n    <section class=\"billing-panel\">\n        <slot />\n    </section>\n</template>\n\n<script>\nexport default {\n    name: 'BillingPanel',\n};\n</script>\n\n<style scoped>\n.billing-panel {\n    background: var(--billing-card-bg);\n    border: 1px solid var(--billing-border);\n    border-radius: 8px;\n    box-shadow: 0 18px 40px rgba(4, 14, 30, 0.12);\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
